"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeReducers = void 0;

/**
 * Sequentially combines reducers to produce a composed reducer.
 *
 * The given reducers are invoked first - to - last with
 * the resulting state of each reducer passed as the state
 * into the next reducer.
 *
 * @param reducers An Array of Reducers, called sequentially
 * @returns a reducer that sequentially invokes the given reducers.
 */
const composeReducers = (...reducers) => (s, action) => reducers.reduce((state, reducer) => reducer(state, action), s);

exports.composeReducers = composeReducers;
//# sourceMappingURL=compose-reducers.js.map
